




















































































































































































































import Vue from 'vue';
import {Ticket} from '@/types/ticket';
import {TicketApi} from '@/api/ticket-api';
import {TicketCategory} from '@/types/ticket-category';
import * as fileSaver from 'file-saver';
import TicketStatistics from '@/components/TicketStatistics.vue';

let confirmDialogAction: any;
export default Vue.extend({
  name: 'Ticket',
  components: {TicketStatistics},
  props: {
    eventId: {
      required: true,
      type: String
    },
    category: {
      required: true,
      type: Array
    }
  },
  mounted(): void {
    this.getByFilter();
  },
  data() {
    return {
      confirmDialog: false,
      showAddDialog: false,
      ticketMark: 'Пачка 1',
      ticketMarkFilter: '',
      onPage: 0,
      length: 0,
      page: 1,
      onPageArray: [10, 50, 100],
      tickets: [] as Ticket[],
      selectedTickets: [] as Ticket[],
      // category: [] as TicketCategory[],
      // categoryName: {} as { [categoryId: string]: string },
      categoryError: '',
      selectedCategory: '',
      selectedCategoryAdd: '',
      loading: false,
      ticketsNumberAdd: 0,
      ticketsNumberAddRules: [
        (v: string) => !!v || 'Обязательное поле',
        (v: string) => Number(v) > 0 || 'введите целое число больше нуля'
      ],
      headers: [
        {text: 'Метка', value: 'mark'},
        {text: 'Категория', value: 'ticketCategory'},
        {text: 'Токен', value: 'token'},
        {text: 'Билет', value: 'link'},
        {text: 'Статистика', value: 'stat'}
        // {text: 'Продан', value: 'sold'},
        // {text: 'Активный', value: 'active'},
        // {text: 'Использован', value: 'used'}
      ],
      ticketToken: '',
      statisticsShow: false
    };
  },
  computed: {
    computedCategory(): any[] {
      return [{title: 'Без фильтра', id: ''}].concat(this.category as any[]);
    },
    categoryName(): { [categoryId: string]: string } {
      return this.category ? (this.category as TicketCategory[]).reduce((acc: any, curr) => {
        acc[curr.id] = curr.title;
        return acc;
      }, {}) : {};
    }
  },
  watch: {
    page(val: number) {
      this.getByFilter((val - 1) * this.onPageArray[this.onPage as number]);
    }
  },
  methods: {
    deleteTicket(index: number) {
      const ticket = this.tickets.splice(index, 1);
      TicketApi.delete(ticket[0].token);
    },
    getByFilter(offset: number = 0) {
      if (!this.onPageArray[this.onPage]) {
        return;
      }
      this.loading = true;
      this.categoryError = '';
      TicketApi.getListFilter({
        category: this.selectedCategory,
        allCategory: this.category as TicketCategory[],
        ticketMarkFilter: this.ticketMarkFilter,
        onPage: this.onPageArray[this.onPage],
        offset: offset
      }).then(res => {
        this.tickets = res.data.data;
        this.length = res.data.pageCount ? res.data.pageCount : 0;
        this.loading = false;
      });
    },
    async add() {
      if (!this.selectedCategoryAdd) {
        this.categoryError = 'Выберите категорию';
        return;
      }
      if (!this.ticketsNumberAdd) {
        return;
      }
      this.categoryError = '';
      this.showAddDialog = false;
      const tickets = Array(Number(this.ticketsNumberAdd)).fill(null).map(e => new Ticket(this.selectedCategoryAdd, this.ticketMark));

      await TicketApi.saveBulk(tickets);
      this.getByFilter();
    },
    async editSelected(tickets: Ticket[]) {
      await TicketApi.editBulk(tickets);
      this.selectedTickets = [];
      this.getByFilter();
    },
    confirmDialogCallBack() {
      this.confirmDialog = false;
      confirmDialogAction();
    },
    confirmDialogCallBackSet(f: any) {
      this.confirmDialog = true;
      confirmDialogAction = f;
    },
    markAsSold() {
      this.editSelected(this.selectedTickets.map(t => ({...t, sold: true})));
    },
    markAsActive() {
      this.editSelected(this.selectedTickets.map(t => ({...t, active: !t.active})));
    },
    markAsUsed() {
      this.editSelected(this.selectedTickets.map(t => ({...t, used: true})));
    },
    openTicketLink(token: string) {
      window.open(`https://ticket.vrcast.tv/${this.$store.state.initiator.alias}/${token}`, '_blank')
    },
    ticketExport() {
      TicketApi.getListFilter({
        category: this.selectedCategory,
        allCategory: this.category as TicketCategory[],
        ticketMarkFilter: this.ticketMarkFilter,
        onPage: 5000,
        offset: this.page - 1,
      }).then(res => {
        let rows = 'название категории;метка билета;токен билета\n';
        rows += '\uFEFF' + res.data.data.map(t => `${(t.ticketCategory as any).title};${t.mark || ' - '};https://ticket.vrcast.tv/${this.$store.state.initiator.alias}/${t.token}`).join('\n');
        const blob = new Blob([rows], {type: 'text/csv; charset=UTF-8', endings: 'transparent'});
        fileSaver(blob, 'export.csv');
      });
    },
    ticketStatistics(id: string) {
      this.statisticsShow = true;
      this.ticketToken = id;
    },
    statisticsClose() {
      this.statisticsShow = false;
      this.ticketToken = '';
    }
  }
});
